import {Property} from '@mintdata/mint-kit/api/decorators/Property';
import {Color} from '@mintdata/mint-kit/api/models/Color';
import {ABoolean} from '@mintdata/mint-kit/api/values/ABoolean';
import {ABooleanConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/ABooleanConfig';
import {ColorConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/ColorConfig';

export class ColorWithVisibility
{
    @Property<Color>({
        title: '',
        tip: ``,
        isRequired: true,
        typeConfig: ColorConfig,
        typeCtor: Color,
    })
    color:Color;

    @Property<ABoolean>({
        title: '',
        tip: ``,
        isRequired: true,
        typeConfig: ABooleanConfig,
        typeCtor: ABoolean
    })
    visibility:ABoolean = ABoolean.true();

    constructor(color:Color, visibility:ABoolean)
    {
        this.color = color;
        this.visibility = visibility;
    }

    public toCssString():string
    {
        return this.visibility.value
            ? this.color.toCssString()
            : 'transparent';
    }

    public toString():string
    {
        return this.toCssString();
    }

    public static fromHexAlpha(hex:string, alpha:number, isVisible?:boolean):ColorWithVisibility
    {
        const visibility = isVisible === undefined
            ? ABoolean.true()
            : isVisible ? ABoolean.true() : ABoolean.false();

        return new ColorWithVisibility(Color.fromHexAlpha(hex, alpha), visibility);
    }

    public static black():ColorWithVisibility
    {
        return new ColorWithVisibility(Color.black(), ABoolean.true());
    }

    public static white():ColorWithVisibility
    {
        return new ColorWithVisibility(Color.white(), ABoolean.true());
    }

    public static blackInvisible():ColorWithVisibility
    {
        return new ColorWithVisibility(Color.black(), ABoolean.false());
    }

    public static whiteInvisible():ColorWithVisibility
    {
        return new ColorWithVisibility(Color.white(), ABoolean.false());
    }

    public static awesome():Array<ColorWithVisibility>
    {
        return Color.awesome()
            .map((color) => new ColorWithVisibility(color, ABoolean.true()));
    }
}
